import {
  REQUEST_GET_FAQS,
  SUCCESS_GET_FAQS,
  FAILURE_GET_FAQS,
} from '../constants/types';

const initialState = {
  errorMessage: '',
  requested: false,
  loading: false,
  data: [],
};

const FAQsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GET_FAQS:
      return { ...state, loading: true };

    case SUCCESS_GET_FAQS:
      return { ...state, requested: true, loading: false, data: action.payload.data };

    case FAILURE_GET_FAQS:
      return { ...state, loading: false, errorMessage: action.payload.err };

    default:
      return { ...state };
  }
};

export default FAQsReducer;
